<template>
  <div>
    <BreadCrumb class="bread" :breads="['设备管理','提货点管理',title]"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">{{title}}</span>
        <router-link :to="{path:'/index/PickupMangement'}">
          <el-button class="addCustom" size="small" icon="el-icon-arrow-left">
            返回列表
          </el-button>
        </router-link>
      </div>
    </div>
    <el-form ref="form" size="small" class="form-container" label-width="120px" :rules="rules" :model="formData" v-loading="loading">
      <div class="form-container__left">
        <el-form-item label="提货点简称" prop="name">
          <el-input v-model="formData.name" maxlength="30" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="核销人手机" prop="verification_phone">
          <el-input v-model="formData.verification_phone" maxlength="11" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="禁用状态" prop="status_name" style="width:100%;">
          <el-radio v-model="formData.status_name" label="正常">否</el-radio>
          <el-radio v-model="formData.status_name" label="禁用">是</el-radio>
        </el-form-item>
        <el-form-item label="市" prop="cid">
          <el-select @change="cityChange" class="lineItem" placeholder="请选择" v-model="formData.cid" :disabled="isView">
            <el-option v-for="item in city_options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提货地址" prop="address">
          <el-input v-model="formData.address" maxlength="30" type="textarea" :rows="5" :disabled="isView"></el-input>
        </el-form-item>
      </div>
      <div class="form-container__right">
        <el-form-item label="核销人" prop="verification_name">
          <el-input v-model="formData.verification_name" maxlength="20" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="提货时间" prop="s_time">
          <el-time-select v-model="formData.s_time" :disabled="isView" style="width:120px;" :picker-options="pickerOption" placeholder="选择时间">
          </el-time-select>
          ~
          <el-time-select v-model="formData.e_time" :disabled="isView" style="width:120px;" :picker-options="pickerOption" placeholder="选择时间">
          </el-time-select>
          每日
        </el-form-item>
        <el-form-item label="省" prop="pid">
          <el-select @change="changeProvince" class="lineItem" placeholder="请选择" v-model="formData.pid" :disabled="isView">
            <el-option v-for="item in province_options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区" prop="code">
          <el-select class="lineItem" placeholder="请选择" v-model="formData.code" :disabled="isView">
            <el-option v-for="item in area_options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div class="table-con">
      <div class="table-con__header">
        <div class="table-con__header-operate">
          <el-button class="table-con__header-button" size="small" v-if="!isView" @click="openSelectGoods('')">新增</el-button>
        </div>
      </div>
      <el-table :data="formData.items_list" stripe :row-class-name="tableRowClassName">
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="items_name" label="商品名称" align="center">
        </el-table-column>
        <el-table-column prop="category_name" label="分类" align="center">
        </el-table-column>
        <el-table-column prop="inside_number" label="内部编码" align="center">
        </el-table-column>
        <el-table-column label="计量单位" align="center" prop="mall_unit"></el-table-column>
        <el-table-column label="数量" align="center" prop="mall_qty"></el-table-column>
        <el-table-column label="原价" align="center" prop="mall_price"></el-table-column>
        <el-table-column label="售价(元)" align="center" prop="real_price">
          <div slot-scope="scope">
            <el-input v-model="scope.row.real_price" size="small" class="table-con__input" @change="validatePrice(scope.row,scope.$index)" maxlength="4"></el-input>
            <div class="table-error" style="color:red">{{scope.row.price_error}}</div>
          </div>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180px">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="openSelectGoods(scope.row)" v-if="!isView">选择</el-button>
            <el-button type="danger" size="small" @click="deleteRow(scope)" v-if="!isView">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="submit-container" v-if="!isView">
      <el-button type="warning" @click="add" v-if="!this.$route.query.id">提交并继续添加</el-button>
      <el-button type="primary" @click="submitAdd">提交</el-button>
      <el-button @click="reset" v-if="!this.$route.query.id">重置</el-button>
    </div>
    <select-goods-dialog :show="selectGoodsVisible" @close="closePickUpDialog" :mode="mode"></select-goods-dialog>
  </div>
</template>
<script>
import BreadCrumb from "@/components/BreadCrumb.vue";
import apis from "@/config/apis/index";
import SelectGoodsDialog from "@/components/SelectPickupDialog.vue";
import {
  isNumber_AZ_Chinese,
  isPhone,
  validate_decimal,
  isNumber
} from "@/plugins/common";
import { deepClone } from "@/plugins/util";
export default {
  data() {
    var validateStime = (rule, value, callback) => {
      if (this.formData.s_time >= this.formData.e_time) {
        callback(new Error("结束时间大于开始时间"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        status_name: "正常",
        verification_name: "",
        verification_phone: "",
        s_time: "08:00",
        e_time: "22:00",
        status: "NORMAL",
        address: "",
        name: "",
        pid: "",
        cid: "",
        code: "",
        items_list: []
      },
      loading: false,
      err: false,
      secDiscable: false,
      province_options: [],
      city_options: [],
      area_options: [],
      mode: "",
      selectGoodsVisible: false,
      selectRow: {},
      dialogShow: false,
      pickerOption: {
        start: "00:00",
        step: "00:15",
        end: "24:00"
      },
      rules: {
        pid: [
          {
            required: true,
            message: "请选择省"
          }
        ],
        cid: [
          {
            required: true,
            message: "请选择市"
          }
        ],
        code: [
          {
            required: true,
            message: "请选择区"
          }
        ],
        s_time: [
          {
            required: true,
            validator: this.validateStime
          }
        ],
        address: [
          {
            required: true,
            message: "请填写正确的地址"
          }
        ],
        name: {
          required: true,
          validator: function(rule, value, callback) {
            if (isNumber_AZ_Chinese(value)) {
              return callback();
            } else {
              return callback(new Error("请输入中文或者字母，最大30个字符"));
            }
          }
        },
        verification_name: {
          required: true,
          validator: function(rule, value, callback) {
            if (isNumber_AZ_Chinese(value)) {
              return callback();
            } else {
              return callback(new Error("请输入中文或者字母，最大20个字符"));
            }
          }
        },
        verification_phone: {
          required: true,
          validator: function(rule, value, callback) {
            if (isPhone(value)) {
              return callback();
            } else {
              return callback(new Error("请输入正确的手机号码"));
            }
          }
        }
      }
    };
  },
  components: {
    BreadCrumb,
    SelectGoodsDialog
  },
  computed: {
    title() {
      if (this.$route.query.operate === "look") {
        this.isView = true;
        return "查看提货点";
      } else {
        this.isView = false;
        if (!this.$route.query.id) {
          return "新增提货点";
          this.loading = false;
        } else {
          return "修改提货点";
          this.loading = true;
        }
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getData(this.$route.query.id);
    }
  },

  mounted() {
    this.getlprovice();
  },
  methods: {
    getData(id) {
      this.$axios.get(apis.goods_point + "/" + id).then(res => {
        if (res.data.code == 200) {
          let {
            address,
            verification_name,
            verification_phone,
            s_time,
            e_time,
            status_name,
            name,
            pid,
            cid,
            code
          } = res.data.data.goods_point;
          let thatStatus =
            status_name === "NORMOL"
              ? "正常"
              : status_name === "DISABLE"
                ? "禁用"
                : "";
          let thatStime = s_time.substring(0, 5);
          let thatEtime = e_time.substring(0, 5);
          this.formData = {
            address: address,
            verification_name: verification_name,
            verification_phone: verification_phone,
            s_time: thatStime,
            e_time: thatEtime,
            status_name: thatStatus,
            name: name,
            pid: pid,
            cid: cid,
            code: code
          };
          this.formData.items_list = res.data.data.entrys;
        }
      });
    },
    //获取省份
    getlprovice() {
      if (this.$route.query.id) {
        this.loading = true;
        this.$axios.get(apis.getProvice).then(data => {
          let datas = data.data;
          if (datas.code == 200) {
            this.province_options = datas.data;
            this.getCity();
          }
        });
      } else {
        this.loading = false;
        this.$axios.get(apis.getProvice).then(data => {
          let datas = data.data;
          if (datas.code == 200) {
            this.province_options = datas.data;
          }
        });
      }
    },
    /*请求市*/
    async getCity(type = "default") {
      let jsondata = {
        pid: this.formData.pid
      };
      await this.$axios.post(apis.getCity, jsondata).then(data => {
        let datas = data.data;
        if (!this.$route.query.id) {
          if (datas.code == 200) {
            this.city_options = datas.data;
          }
        } else {
          if (datas.code == 200) {
            this.city_options = datas.data;
          }
          // console.log(datas.data[0].id);
          this.formData.cid = datas.data[0].id;
          this.getArea();
        }
      });
    },
    /*省选择*/
    changeProvince(event, item) {
      this.pids = event;
      this.formData.cid = "";
      this.formData.code = "";
      this.getCity();
    },
    /*市选择*/
    cityChange(event, item) {
      this.formData.code = "";
      this.formData.cid = event;
      this.getArea();
    },
    /*区选择*/
    getArea() {
      let jsondata = {
        cid: this.formData.cid
      };
      this.$axios.post(apis.getArea, jsondata).then(data => {
        let datas = data.data;
        if (datas.code === 200) {
          this.area_options = datas.data;
        }
      });
      this.loading = false;
    },
    //打开选择商品
    openSelectGoods(data) {
      this.selectGoodsVisible = true;
      this.selectRow = data;
    },
    closePickUpDialog(data) {
      if (data.id) {
        var _shopData = {
          category_name: data.category_name,
          inside_number: data.inside_number,
          items_id: data.id,
          items_name: data.mall_name,
          mall_price: data.mall_price,
          mall_qty: data.mall_qty,
          mall_unit: data.mall_unit,
          real_price: data.mall_price
        };
        this.formData.items_list.forEach(item => {
          if (item.items_id == _shopData.items_id) {
            this.$message({
              type: "error",
              message: "已存在重复商品"
            });
            this.selectGoodsVisible = false;
            callback();
          }
        });
        //   console.log(item.item_id);
        // if (err.length > 0) {
        //     this.$message({
        //         type: "error",
        //         message: "已存在重复商品"
        //     });
        //     this.selectGoodsVisible = false;
        //     return;
        // }
        //替换当前商品
        if (this.selectRow) {
          this.formData.items_list.forEach((item, index) => {
            if (item.items_id == _shopData.items_id) {
              this.$message({
                type: "error",
                message: "已存在重复商品"
              });
              this.selectGoodsVisible = false;
              return;
            } else if (this.selectRow.items_id === item.items_id) {
              this.$set(this.formData.items_list, index, _shopData);
            }
          });
        } else {
          this.formData.items_list.push(_shopData);
        }
      }
      this.selectGoodsVisible = false;
    },
    //删除一行
    deleteRow(row) {
      this.formData.items_list.splice(row.$index, 1);
    },
    //提交但不跳转
    submitAdd() {
      let _this = this;
      this.submit(function() {
        _this.$router.push("/index/pickupMangement");
      });
    },
    add() {
      let _this = this;
      this.submit(function() {
        _this.reset();
      });
    },
    //提交
    submit(fn) {
      var _formData = deepClone(this.formData);
      if (_formData.items_list.length == 0) {
        this.$message({
          type: "error",
          message: "请选择商品"
        });
        return;
      }
      //存储数据更改
      _formData.items_list.forEach((item, index) => {
        if (item.price_error) {
          err = true;
          return;
        }
        item.real_price = item.real_price * 100;
        console.log(item.real_price);
      });
      let thatStatus =
        this.formData.status_name === "正常"
          ? "NORMOL"
          : this.formData.status_name === "禁用"
            ? "DISABLE"
            : "";
      let submitData = {
        name: this.formData.name,
        verification_name: this.formData.verification_name,
        verification_phone: this.formData.verification_phone,
        status: thatStatus,
        s_time: this.formData.s_time,
        e_time: this.formData.e_time,
        address: this.formData.address,
        code: this.formData.code,
        items: _formData.items_list
        // items: this.formData.items_list
      };
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.formData.items_list.forEach((item, index) => {
            this.validatePrice(item, index);
          });
          let _formData = deepClone(this.formData);
          //存储数据更改
          _formData.items_list.forEach((item, index) => {
            if (item.price_error) {
              err = true;
              return;
            }
            item.real_price = item.real_price * 100;
            console.log(item.real_price);
          });
          if (!this.$route.query.id) {
            this.$axios.post(apis.goods_point, submitData).then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: "success",
                  message: res.data.msg
                });
                fn();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg
                });
              }
            });
          } else {
            this.$axios
              .post(apis.goods_point + "/" + this.$route.query.id, submitData)
              .then(res => {
                if (res.data.code === 200) {
                  this.$message({
                    type: "success",
                    message: res.data.msg
                  });
                  fn();
                } else {
                  this.$message({
                    type: "error",
                    message: res.data.msg
                  });
                }
              });
          }
        }
      });
    },
    //重置
    reset() {
      this.$refs["form"].resetFields();
      this.formData.items_list = [];
    },
    goBack() {
      this.$router.push({
        name: "shoppingCategory"
      });
    },
    validatePrice(item, index) {
      if (!item.real_price) {
        this.$set(
          this.formData.items_list[index],
          "price_error",
          "售价必须填写"
        );
      } else if (!validate_decimal(item.real_price)) {
        this.$set(
          this.formData.items_list[index],
          "price_error",
          "售价必须填写数字"
        );
      } else if (+item.real_price < 0.01) {
        this.$set(
          this.formData.items_list[index],
          "price_error",
          "售价必须大于0.01"
        );
      } else {
        this.$set(this.formData.items_list[index], "price_error", "");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import url("../../../assets/css/common.scss");

.table-con__header {
  padding: 15px;
}

.table-con__header-title {
  font-weight: bold;
  color: #1ab394;
}

.table-con__count {
  padding: 10px;
  font-size: 12px;
  color: #666;
}

.table-con__footer {
  margin-top: 15px;
  text-align: center;
}

.table-con__header-operate {
  margin-top: 15px;
}

.submit-container {
  margin-top: 20px;
}

.dialog-tip {
  font-size: 12px;
  color: red;
}
</style>
